import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import {deleteAttachmentFile, toggleEditDisplayNameModal,getSearchToken, deleteBrochure} from '../../../actions/products';
import MoreMenu from 'jd-library/MoreMenu';
import styles from './scss/uploaded-files.scss';
const UploadedFiles = props => {
    const {
        uploadedCount=0,
        previouslyUploadedCount=0
	} = props.progressProps;
    const [auditBrocherStickyNudge, setAuditBrocherStickyNudge] = useState(props.auditPendingCount)   
         
    useEffect(() => {
      setAuditBrocherStickyNudge(props.auditPendingCount)
    }, [props.auditPendingCount])

    const deleteFile = (itemToDelete) => {
        if(props.fromAttachment){
            props.deleteAttachmentFile({productId: props.productId, fileKey:itemToDelete.fileKey});
        }else if(props.fromFileModule) {
            props.deleteCb && props.deleteCb(itemToDelete,() => {
                props.deleteAttachmentFile({productId: props.productId, fileKey:itemToDelete.fileKey});
            });
        }else {
            props.deleteBrochure({brochureId: itemToDelete.brochureId, fileId: itemToDelete.fileId});
        }
    }
    
    function formatAuditDate(dateStr) {
        const date = new Date(dateStr);

        const day = date.getDate().toString().padStart(2, '0');
        const monthShort = date.toLocaleString('en-US', { month: 'short' });
        const yearShort = `'${date.getFullYear().toString().slice(-2)}`;

        const time = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });

        return `${day} ${monthShort} ${yearShort}, ${time}`;
    }

    const downloadAttachment = (itemToDownload) => {
        let url = '';
        if(props.isJdVendor){
            url = `${window.location.origin}/marketplace/static/php/web/b2bWebsite.php?&action=downloadAttachment&fileId=${itemToDownload.id}`;
        }else{
            let token = getSearchToken({token:props.token});            
            if(props.fromAttachment) {
                url = `${window.location.origin}/marketplace/static/php/web/b2bWebsite.php?action=downloadAttachment&token=${token}&fileId=${itemToDownload.id}`;
            }else {
                url = `${window.location.origin}/marketplace/static/php/web/b2bBrochure.php?action=downloadBrochure&token=${token}&fileId=${itemToDownload.fileId}`;
            }
        }
        if(props.isIphone && !props.isIphoneApp) {
            window.location.href = url;
        } else if (props.isIphoneApp && window?.webkit?.messageHandlers && window?.webkit?.messageHandlers["downloadFile"]) {
            window.webkit.messageHandlers["downloadFile"].postMessage(url);
            return true;
        } else {
            window.open(url, "_blank");
        }
    }

    const getLabelWithIcon = (label,iconClass) => {
        return(
            <>
                <span className={`${iconClass}`}> </span>
                <span className={`${styles['file-label']}`}>{label}</span>
            </>
        )
    }
    
    const editDisplayName = (itemToEdit) => {
        let modalData = {
            fileName: itemToEdit.fileName.split('.')[0]
        }
        props.toggleEditDisplayNameModal({show: true, modalData, currentFile: itemToEdit, fromAttachment: props.fromAttachment});
    }

   const getUploadedFilesList = () => {
       let uploadedFilesList = [];
       props.fileAttachmentArr.forEach((item,index)=> {

        let moreMenuList = [
            {
                label: getLabelWithIcon('Delete','icon-trash'),
                onClick: () => {deleteFile(item)}
            }
        ];

        if(!props.isReadOnly){
            moreMenuList.unshift({
                label: getLabelWithIcon('Download','icon-download'),
                onClick: () => {downloadAttachment(item)}
            })
        }
        if(!props.fromAttachment) {
            moreMenuList.unshift({
                label: getLabelWithIcon('Edit Display Name','icon-editItem'),
                onClick: () => {editDisplayName(item)}
            })
        }

        if(props.fromFileModule) {
            moreMenuList = [
                {
                    label: getLabelWithIcon('Delete','icon-trash'),
                    onClick: () => {deleteFile(item)}
                }
            ];
        }

        if(item.uploaded && !item.isDeleted){
                uploadedFilesList.push(
                    <div className={styles['file-name-main']} key = {item.id || item.fileKey}>

                        <div className={styles['file-name-extn']}>
                        <div className={`${styles['file-ext-main']} ${styles[item.ext]}`}>
                                <div className={styles['ext-name']}>{item.ext}</div>
                        </div>    
                        <div className={styles['name-parent']}>
                                <div className={styles['file-name']}>{item.fileName}</div>
                                {!props.fromFileModule ? 
                                props.fromAttachment ? 
                                (props.isReadOnly ? null : (<div className={`${styles['edit-name-main']} ${props.isMobile ? '' : 'hover-class'}`} onClick={() => editDisplayName(item)}>
                                    <div className='icon-editItem'></div>
                                    <div className={styles['edit-name']}>EDIT DISPLAY NAME</div>
                                </div>))
                                : (<div className={`${styles['edit-name-main']} ${props.isMobile ? '' : 'hover-class'}`} onClick={() => props.imagePreviewRef.current.onImageClick({clickedImageIndex: index})}>
                                    <div className='icon-gallerySM'></div>
                                    <div className={styles['edit-name']}>View File Preview</div>
                                </div>)
                                : null }
                        </div>
                        </div>  
                        {props.isReadOnly ? null : (<div className='more-menu-parent'>
                                <MoreMenu
                                    list = {moreMenuList}
                                    menuClass = {styles['delete-btn']}
                                    customClass = {props.isMobile ? '' : styles['custom-style']}
                                />
                        </div>)}     
                    </div> 
                );
           }
       });

       return uploadedFilesList;
   } 
   const infoDetail = {
        infoText: props.fromAttachment ? ['Upload upto 5 files of 25 MB each. Supported formats are images, PDF and Microsoft Office Documents.'] : !props.fromFileModule ? ["Supported formats are <span class='info-text-bold-format'>JPG, JPEG, PNG, WEBP and PDF Documents</span>. <span class='info-text-bold'>DO NOT</span> Upload your business premise photos as they will get rejected"]: ['Supported size for each file is 15 MB and total size is 100 MB']
   }
   return(
        <>
        {auditBrocherStickyNudge  && props?.isBrochure? (
            <div className={`${styles['upload-info']} ${styles['upload-info-sticky']} ${!props.isContractor && props.isMobile ? styles['mob'] : ''}`} >
                <span className={'icon-Info sticky-nudge-info'}></span>
                <div>Last {props.brochureButton ? props.brochureButton : 'Brochure' } Upload on <span className='info-text-bold-format'>{props.latestDtTmoFAuditPending && formatAuditDate(props.latestDtTmoFAuditPending)}</span>{props.isMobile ? <br/> : '. '} {props.brochureButton ? props.brochureButton : 'Brochure' }{props?.auditPendingCount > 1 ? '(s)' : '' } in Audit Pending state will be reviewed within 3 working days before it goes live</div>
                    {/* <span className="icon-HDRcross" onClick={() => setAuditBrocherStickyNudge(false)}></span> */}
                </div>
          ): null}
      <div className={styles['uploaded-files-main']+ " " + (props.isMobile ? 'isMobile': 'isWeb') + " " + (props.isReadOnly ? styles['uploaded-files-main-readonly'] : '')}>
          {(((uploadedCount || previouslyUploadedCount) && !props.isReadOnly) || props.isBrochure) ?
          <>
          <div className={styles['upload-info']}>
              <span className={'icon-Info'}></span>
              <div className={props.fromAttachment ? `${styles['info-text']}` : `${styles['info-text']} ${styles['brochure-info']}`}>
              {infoDetail.infoText.map((text, i) => 
              <div key={i*Math.random()} className={styles['info-text-container']} dangerouslySetInnerHTML={{__html: text}} />
              )}
              </div>
          </div>
          </> : null }
          {props.uploadBtns ? props.uploadBtns() : null}
          {props.isBrochure ? null : getUploadedFilesList()}
      </div>
      </>
   )
}

const mapStateToProps = (state,props) => {
    let fileAttachmentArr = state.products.allProducts[props.productId]?.fileAttachmentArr || [];
    if(state.products.brochureAttachment.fileAttachments?.length && !props.fromAttachment){
        fileAttachmentArr = state.products.brochureAttachment.fileAttachments;
    }
	return {
		...props,
        fileAttachmentArr,
        isMobile: state.deviceData.isMobile,
        isIphoneApp: state.deviceData.isIphoneApp,
        isIphone: state.deviceData.isIphone,
        token: state.session.token,
        latestDtTmoFAuditPending: state.products.brochureAttachment.latestDtTmoFAuditPending,
		auditPendingCount: state.products.brochureAttachment.auditPendingCount,
        brochureButton: state.session.brochureButton,
        ...state.products.fileAttachmentData
	}
}
export default connect(mapStateToProps, {deleteAttachmentFile, toggleEditDisplayNameModal,deleteBrochure})(UploadedFiles);